import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEraserSimple: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconEraserSimple"><Path d="M6.5 10.5L13.5 17.5" stroke="currentColor"/><Path d="M14.5 2.5L2.5 14.5L9.5 21.5L21.5 9.5L14.5 2.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconEraserSimple;
